<template>
  <t-form label-width="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="形状">
      <e-shape-select v-model="attribute.shape"/>
    </t-form-item>
    <t-form-item label="占比">
      <t-input-number v-model="attribute.radius" size="small" :min="40" :max="100" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="波浪振幅">
      <t-input-number v-model="attribute.amplitude" size="small" :min="0" :max="100" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="波浪颜色">
      <div>
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.colorTop" size="small"/>
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.colorBottom" size="small"/>
      </div>
    </t-form-item>
    <t-form-item label="波浪数量">
      <t-input-number size="small" v-model="attribute.waveNum" :min="1" :max="10" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="背景颜色">
      <div>
        <t-color-picker :colorModes="['monochrome']" v-model="attribute.backgroundColorTop" size="small" enableAlpha format="RGBA"/>
        <t-color-picker :colorModes="['monochrome']" v-model="attribute.backgroundColorBottom" size="small" enableAlpha format="RGBA"/>
      </div>
    </t-form-item>
    <e-collapse title="数值" :expand="false">
      <t-form-item label="字体大小">
        <t-input-number v-model="attribute.label.fontSize" size="small" :min="2" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="颜色(波浪外)">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.label.color" size="small"/>
      </t-form-item>
      <t-form-item label="颜色(波浪内)">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.label.insideColor" size="small"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="边框" :expand="false">
      <t-form-item label="间隔">
        <t-input-number v-model="attribute.outline.borderDistance" size="small" :min="0" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="宽度">
        <t-input-number v-model="attribute.outline.borderWidth" size="small" :min="0" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="颜色">
        <div>
          <t-color-picker :colorModes="['monochrome']" v-model="attribute.outline.borderColorTop" size="small" enableAlpha format="RGBA"/>
          <t-color-picker :colorModes="['monochrome']" v-model="attribute.outline.borderColorBottom" size="small" enableAlpha format="RGBA"/>
        </div>
      </t-form-item>
      <t-form-item label="阴影">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.outline.shadowColor" size="small"/>
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script setup>
import { ref } from 'vue';
import CptData from '@/components/element/options/comp/cpt-data'
import EShapeSelect from "@/components/designer/e-shape-select.vue";
const currentComponent = ref('CptData');
const props = defineProps({
  attribute:Object,
  cptDataForm:Object,
})

</script>

<style scoped>

</style>